<template>
	<div class="p-3">
		<alert-widget-settings-content />
	</div>
</template>

<script>
import AlertWidgetSettingsContent from '@/components/Widget/AlertWidgetSettingsContent.vue';

export default {
	components: { AlertWidgetSettingsContent },
	created() {
		this.$auth.loadFromLocalStorage();
		if(!this.$auth.isLoggedIn()) {
			document.location = `${process.env.VUE_APP_PIPIPUPUBASE}/app?redirect=${document.location}`;
		}
	},
};
</script>

<style>
html, body, #app {
	margin: 0;
	padding: 0;
}
</style>
